import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "../assets/css/style.css";
 import "bootstrap/dist/js/bootstrap.min.js";
import userIcon from "../assets/images/user.png";

const Footer = () => {
  return (
     
      <div className="bottom-nav d-none">
      <a href="#" className="active">
        <i className="bi bi-house"></i>
        <span>Home</span>
      </a>
      <a href="#">
        <i className="bi bi-box-seam"></i>
        <span>Delivered</span>
      </a>
      <a href="#">
        <i className="bi bi-x-circle"></i>
        <span>Canceled</span>
      </a>
      <a href="#">
        <i className="bi bi-envelope"></i>
        <span>Mails</span>
      </a> 
      </div>
       
  );
};

export default Footer;
